import React, { useState, useEffect } from 'react';
import { CiMenuBurger, CiShoppingCart, CiSearch } from 'react-icons/ci';
import { useLocation, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SideBarMenu from '../Side/SideBarMenu';
import SideBarPanier from '../Side/SideBarPanier';
import logoImage from '../../assets/img/logoreal.png';
import './NavBar.css';

const NavBar = () => {
  const [isMenuOpen, setIsMenuOpen]   = useState(false);
  const [isCartOpen, setIsCartOpen]   = useState(false);
  const [isScrolled, setIsScrolled]   = useState(false);
  const location  = useLocation();
  const cartItems = useSelector((state) => state.cart);
  const totalQty  = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > 5);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  /* Couleur des icones : blanc sur hero, espresso apres scroll ou sur pages interieures */
  const iconColor = !isScrolled && location.pathname === '/' ? 'text-white' : 'text-white';

  return (
    <>
      <nav
        className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
        style={{
          backgroundColor: isScrolled ? 'rgba(46,35,24,0.97)' : 'transparent',
          backdropFilter:  isScrolled ? 'blur(8px)' : 'none',
          borderBottom:    isScrolled ? '1px solid rgba(217,166,65,0.2)' : 'none',
        }}
      >
        <div className="grid grid-cols-3 items-center h-20 px-4 md:px-8">

          {/* Hamburger gauche */}
          <div className="flex justify-start">
            <button
              onClick={() => setIsMenuOpen(true)}
              className="rounded-full p-2 transition-all duration-300 hover:bg-white/10"
              aria-label="Menu"
            >
              <CiMenuBurger className={`text-3xl ${iconColor}`} />
            </button>
          </div>

          {/* Logo centre */}
          <div className="flex justify-center">
            {isScrolled ? (
              <NavLink to="/" className="font-sans text-base md:text-lg tracking-widest text-white">
                Au Coing du Ventoux
              </NavLink>
            ) : (
              <NavLink to="/" className="absolute top-3 left-1/2 -translate-x-1/2">
                <img src={logoImage} alt="Logo" className="h-28 md:h-32 lg:h-36 drop-shadow-lg" />
              </NavLink>
            )}
          </div>

          {/* Icones droite */}
          <div className="flex items-center justify-end gap-1">
            <button
              className="hidden lg:flex rounded-full p-2 transition-all duration-300 hover:bg-white/10"
              aria-label="Rechercher"
            >
              
            </button>

            <button
              onClick={() => setIsCartOpen(true)}
              className="relative rounded-full p-2 transition-all duration-300 hover:bg-white/10"
              aria-label="Panier"
            >
              <CiShoppingCart className={`text-3xl ${iconColor}`} />
              {totalQty > 0 && (
                <span
                  className="absolute top-0.5 right-0.5 flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold text-white"
                  style={{ backgroundColor: '#C8951F' }}
                >
                  {totalQty}
                </span>
              )}
            </button>
          </div>

        </div>
      </nav>

      <SideBarMenu   isOpen={isMenuOpen} toggleSidebar={() => setIsMenuOpen(false)} />
      <SideBarPanier isOpen={isCartOpen} toggleSidebar={() => setIsCartOpen(false)} cartItems={cartItems} />
    </>
  );
};

export default NavBar;